import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#090A0F] grid-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center bg-[#12141D] border border-white/10 rounded-3xl p-10 shadow-2xl animate-float-in">
        <XCircle className="w-12 h-12 text-slate-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-white mt-6">Abo abgebrochen</h1>
        <p className="text-slate-400 text-sm mt-2">Kein Problem – du kannst jederzeit VIP werden.</p>
        <button
          data-testid="cancel-back-btn"
          onClick={() => navigate("/vip")}
          className="mt-8 w-full bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-semibold rounded-xl py-3 active:scale-95 transition-all"
        >
          Zurück zur VIP-Seite
        </button>
      </div>
    </div>
  );
}
